const getTeamIdsAsFields = (totalNumberOfTeams: number) => {
  const result = [];
  for (let team = 1; team <= totalNumberOfTeams; team++) {
    result.push(team.toString());
  }
  return result;
};

export default getTeamIdsAsFields;
